import { AdjustmentNoteInput } from './AdjustmentNoteInput';

export default AdjustmentNoteInput;
